// extracted by mini-css-extract-plugin
export default {"root":"DefaultLayout_root__-bp6G","content":"DefaultLayout_content__Qfeb7","footer":"DefaultLayout_footer__vrBS8"};